module.exports = __webpack_public_path__ + "static/media/arrow.7fec05d4.svg";